var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2812 7.71094C10.6264 7.71094 10.9062 7.99076 10.9062 8.33594V10.8359C10.9062 11.1811 10.6264 11.4609 10.2812 11.4609C9.93607 11.4609 9.65625 11.1811 9.65625 10.8359V8.33594C9.65625 7.99076 9.93607 7.71094 10.2812 7.71094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2786 14.1667C10.7389 14.1667 11.112 13.7936 11.112 13.3333C11.112 12.8731 10.7389 12.5 10.2786 12.5C9.81841 12.5 9.44531 12.8731 9.44531 13.3333C9.44531 13.7936 9.81841 14.1667 10.2786 14.1667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02519 3.40643C9.58906 2.44786 10.9753 2.44786 11.5392 3.40643L18.4155 15.0962C18.9874 16.0683 18.2864 17.2939 17.1585 17.2939H3.40586C2.27796 17.2939 1.577 16.0683 2.14887 15.0962L9.02519 3.40643ZM10.4618 4.0402C10.3812 3.90327 10.1832 3.90326 10.1026 4.0402L3.22629 15.7299C3.14459 15.8688 3.24473 16.0439 3.40586 16.0439H17.1585C17.3196 16.0439 17.4198 15.8688 17.3381 15.7299L10.4618 4.0402Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.7511441f184fef6c6bb6da7e29b1ae82.svg";
export { ForwardRef as ReactComponent };